import { WrappedFormUtils } from 'antd/lib/form/Form';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

type FormProviderProps = {
  children: React.ReactNode;
} & RouteComponentProps;

type TFormContext = {
  form?: WrappedFormUtils
  onInitForm: (form: WrappedFormUtils) => void
  onDestroyForm: () => void
  resetTouchedFields: () => void
}

const FormContext = createContext<TFormContext>({} as TFormContext)

export const useForm = (form?: WrappedFormUtils): TFormContext => {
  const context = useContext(FormContext)

  useEffect(() => {
    if (!context || !form) return
    const formContext = context
    formContext.onInitForm(form)
    return () => formContext.onDestroyForm()
  }, [context, form])

  return context ?? ({} as TFormContext)
}

export const FormProvider = withRouter(({ children, location, history }: FormProviderProps) => {
  const [form, setForm] = useState<WrappedFormUtils<any>>()

  const onInitForm = (form: WrappedFormUtils) => setForm(form)
  const onDestroyForm = () => setForm(undefined)
  const isFieldsTouched = form?.isFieldsTouched()

  // DETECT RA CÁC FIELD BỊ TOUCHED VÀ RESET VỀ NON-TOUCHED
  const resetTouchedFields = (): void => {
    if (!isFieldsTouched) return

    const fields = form?.getFieldsValue() || {}

    const updatedFields = Object.keys(fields)
      .filter((key) => form?.isFieldTouched(key)) // Chỉ lấy các field đã bị touch
      .reduce((acc, key) => {
        acc[key] = { value: form?.getFieldValue(`${key}`), touched: false };
        return acc;
      }, {} as Record<string, { value: any, touched: boolean }>);

    if (Object.keys(updatedFields).length > 0) return form?.setFields(updatedFields);
  };


  const value = { form, onInitForm, onDestroyForm, resetTouchedFields }

  return (
    <FormContext.Provider value={value}>
      {children}
    </FormContext.Provider>
  )
})

